// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

// material ui
import { Chip, Skeleton, Stack } from '@mui/material';

// components
import { formatNumber } from '@/utils/formatters';

// relative
import EnergyMark from '../EnergyMark';
import type { BenchmarkBuildingInfoProps } from './benchmark';

const BenchmarkBuildingInfo = ({
  benchmarkData,
}: BenchmarkBuildingInfoProps) => {
  const { t } = useTranslation('portfolio-analysis');

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {!benchmarkData.Address ? (
        <Skeleton variant="rectangular" width={100} height={25} />
      ) : (
        <Chip
          icon={<HomeRoundedIcon fontSize="small" />}
          label={benchmarkData.Address}
          variant="outlined"
          size="small"
        />
      )}
      {!benchmarkData.ExtractedBuildingUse ? (
        <Skeleton variant="rectangular" width={100} height={25} />
      ) : (
        <Chip
          label={benchmarkData.ExtractedBuildingUse}
          variant="outlined"
          size="small"
        />
      )}
      {!benchmarkData.SumBuildingArea ? (
        <Skeleton variant="rectangular" width={100} height={25} />
      ) : (
        <Chip
          label={`${formatNumber(benchmarkData.SumBuildingArea)} m²`}
          variant="outlined"
          size="small"
        />
      )}
      {!benchmarkData.TotalMeteringPoints ? (
        <Skeleton variant="rectangular" width={100} height={25} />
      ) : (
        <Chip
          label={`${benchmarkData.TotalMeteringPoints} ${t('benchmarkChart.buildingInfo.meterCount')}`}
          variant="outlined"
          size="small"
        />
      )}
      {benchmarkData.EnergyLabelClassification && (
        <EnergyMark mark={benchmarkData.EnergyLabelClassification} />
      )}
    </Stack>
  );
};

export default BenchmarkBuildingInfo;
